module.exports = __webpack_public_path__ + "img/footer.d3196654.png";